import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getUser } from './user.selectors';

const selectUserPropertiesManagementState = createSelector(
  getUser,
  ({ userPropertiesManagement }) => userPropertiesManagement,
);

export const selectUserProperties = createSelector(
  selectUserPropertiesManagementState,
  userPropertiesManagement => userPropertiesManagement?.properties || [],
);

export const selectFilteredUserProperties = createSelector(
  getDebouncedSearchValue,
  selectUserProperties,
  searchItems(({ name, value }) => [name, value]),
);
